import { get, set } from 'lodash';
import { UtilType } from './UtilType';
export class UtilDocument {
    static isNew(doc) {
        return !doc.systemHeader || !doc.systemHeader.createdDate;
    }
    static isPreviousVersion(doc) {
        return doc.systemHeader && doc.systemHeader.currentVersion === false;
    }
    static isDeleted(doc) {
        const deleted = doc.systemHeader ? doc.systemHeader.deleted : false;
        return deleted === true || deleted === 'true';
    }
    static hasIntersect(srcObj, targetObj) {
        if (!srcObj || !targetObj) {
            return false;
        }
        const keys = Object.keys(targetObj);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            if (UtilType.isDefined(srcObj[key]) &&
                UtilType.isDefined(targetObj[key]) &&
                srcObj[key] === targetObj[key]) {
                return true;
            }
        }
        return false;
    }
    ;
    static filterDocumentFields(doc, targetFieldNames) {
        if (!targetFieldNames || targetFieldNames.length === 0) {
            return doc;
        }
        const result = {};
        targetFieldNames.forEach(function (fieldName) {
            const val = get(doc, fieldName);
            set(result, fieldName, val);
        });
        return result;
    }
}
